import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        let $prevElement
        const isFeaturedType = this.getData('slide-type') ? true : false


        if (isFeaturedType)  {
            $prevElement = this.el.parentElement.previousElementSibling
        } else {
            $prevElement = this.el.previousElementSibling
        }

        if ($prevElement && $prevElement.classList.contains('c-carousel-heading')) {
            this.$prevButton = $prevElement.querySelector('.js-prev')
            this.$nextButton = $prevElement.querySelector('.js-next')
        }
    }

    init() {
        this.initCarousel()

        if (this.$prevButton && this.$nextButton) {
            this.bindEvents()
        }
    }

    destroy() {
        super.destroy()
        this.carousel.destroy(true,true)

        if (this.$prevButton && this.$nextButton) {
            this.unbindEvents()
        }
    }

    /////////////////////////
    // Methods
    initCarousel() {
        const slidesPerView = this.getData('slide')
        const slidesPerViewTablet = this.getData('slide-tablet')
        const slidesPerViewMobile = this.getData('slide-mobile')

        if (!slidesPerView) return

        this.carousel = new Swiper(this.el, {
            slidesPerView: slidesPerViewMobile ? slidesPerViewMobile : slidesPerView,
            threshold: 2,
            spaceBetween: 25,
            grabCursor: true,
            breakpoints: {
                701: {
                    slidesPerView: slidesPerViewTablet ? slidesPerViewTablet : slidesPerView
                },

                1181: {
                    slidesPerView: slidesPerView
                }
            }
        })

        this.checkDisableButtons()
    }

    bindEvents() {
        this.onPrevBind = this.onPrev.bind(this)
        this.onNextBind = this.onNext.bind(this)
        this.$prevButton.addEventListener('click', this.onPrevBind)
        this.$nextButton.addEventListener('click', this.onNextBind)
    }

    unbindEvents() {
        this.$prevButton.removeEventListener('click', this.onPrevBind)
        this.$nextButton.removeEventListener('click', this.onNextBind)
    }

    onPrev() {
        this.carousel && this.carousel.slidePrev()
        this.checkDisableButtons()
    }

    onNext() {
        this.carousel && this.carousel.slideNext()
        this.checkDisableButtons()
    }

    checkDisableButtons() {
        if (this.$prevButton) {
            if (this.carousel.isBeginning) {
                this.$prevButton.disabled = true
            } else {
                this.$prevButton.disabled = false
            }
        }

        if (this.$nextButton) {
            if (this.carousel.isEnd) {
                this.$nextButton.disabled = true
            } else {
                this.$nextButton.disabled = false
            }
        }
    }
}
